import { render, staticRenderFns } from "./TenantProfile.vue?vue&type=template&id=861e5810&"
import script from "./TenantProfile.vue?vue&type=script&lang=js&"
export * from "./TenantProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports